import React from "react";
import "./Card.styles.scss";

interface CardProps {
  titleIcon?: React.ReactNode;
  title?: string;
  actionComponent?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  fullWidth?: boolean;
}

const Card: React.FC<CardProps> = ({
  titleIcon,
  title,
  actionComponent,
  children,
  footer,
  fullWidth = false,
}) => {
  return (
    <div className={`card ${fullWidth ? "full-width" : ""}`}>
      <div className="card-header">
        <div className="card-header-title">
          <div className="card-header-title-icon">{titleIcon}</div>
          <div className="card-header-title-text">{title}</div>
        </div>
        {actionComponent ? (
          <div className="card-header-action">{actionComponent}</div>
        ) : null}
      </div>
      <div className="card-content">{children}</div>
      {footer && <div className="card-footer">{footer}</div>}
    </div>
  );
};

export default Card;
